/**
 * 解析 staff_message_received 中的治疗师呼叫 / 前台处理业务
 *
 * 大屏侧约定：
 * - THERAPIST_CALL：新增未处理呼叫 → 展示告警并暂停轮播
 * - YUYUE_CALL：前台已处理 → 移除告警；全部清空后恢复轮播
 * 告警与患者页轮播 DOM 解耦，不随切页消失。
 * 大屏展示仅两行：房间名（room_name）+ 当前房间治疗师（scheduled_staff_name）；
 * 不展示发起人 caller_staff_name / content（载荷字段仍保留供日志等使用）。
 */

import { expectedYuanqiRoomKey } from '@/utils/roomKeys'

export const BIZ_THERAPIST_CALL = 'THERAPIST_CALL'
export const BIZ_YUYUE_CALL = 'YUYUE_CALL'

/**
 * @param {object} msg WebSocket 下行
 * @param {string|number} storeId 当前大屏门店
 * @returns {{ action: 'add'|'remove', call?: object, callId?: number }|null}
 */
export function parseTherapistNotifyMessage(msg, storeId) {
  if (!msg || msg.type !== 'staff_message_received') return null

  const payload = msg.payload || {}
  const expectedRoom = expectedYuanqiRoomKey(storeId)
  if (expectedRoom && payload.room_key && payload.room_key !== expectedRoom) {
    return null
  }

  let extra = {}
  try {
    const raw = payload.extra_json
    extra = typeof raw === 'string' ? JSON.parse(raw || '{}') : (raw || {})
  } catch (_) {
    return null
  }

  const callId = Number(extra.therapist_call_id)
  if (!Number.isFinite(callId) || callId <= 0) return null

  if (extra.biz_type === BIZ_THERAPIST_CALL) {
    return {
      action: 'add',
      callId,
      call: {
        therapist_call_id: callId,
        medical_service_id: extra.medical_service_id,
        appointment_id: extra.appointment_id,
        room_id: extra.room_id,
        room_name: extra.room_name || '',
        caller_staff_uid: extra.caller_staff_uid,
        caller_staff_name: extra.caller_staff_name || '',
        scheduled_staff_uid: extra.scheduled_staff_uid,
        scheduled_staff_name: extra.scheduled_staff_name || '',
        sent_at: extra.sent_at,
        content: payload.content || ''
      }
    }
  }

  if (extra.biz_type === BIZ_YUYUE_CALL) {
    return {
      action: 'remove',
      callId,
      call: {
        therapist_call_id: callId,
        handled_by_staff_uid: extra.handled_by_staff_uid,
        handled_by_name: extra.handled_by_name || '',
        handled_at: extra.handled_at
      }
    }
  }

  return null
}
